import React, { useState, useEffect } from "react";
import { IoCloseCircle } from "react-icons/io5";
import { FaTag, FaEye } from "react-icons/fa";
import axios from "axios";
import { Link } from "react-router-dom";

const Notification = () => {
  const [latestProducts, setLatestProducts] = useState([]);
  const [currentNotification, setCurrentNotification] = useState(null);
  const [showNotification, setShowNotification] = useState(true);
  const [isExiting, setIsExiting] = useState(false);

  // Fetch latest collection products from API
  useEffect(() => {
    const fetchLatestProducts = async () => {
      try {
        const response = await axios.get(
          "https://ardorbiomed.com/api/api/latest-collection/"
        );
        setLatestProducts(response.data);
      } catch (error) {
        console.error("Error fetching latest products:", error);
      }
    };

    fetchLatestProducts();
  }, []);

  // Automatically cycle through notifications
  useEffect(() => {
    if (showNotification && latestProducts.length > 0) {
      const randomIndex = Math.floor(Math.random() * latestProducts.length);
      setCurrentNotification(latestProducts[randomIndex]);

      const timeout = setTimeout(() => {
        handleCloseWithAnimation();
      }, 10000);

      return () => clearTimeout(timeout);
    }
  }, [showNotification, latestProducts]);

  // Interval to re-show notifications every 30 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setShowNotification(true);
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  // Close notification with animation
  const handleCloseWithAnimation = () => {
    setIsExiting(true);
    setTimeout(() => {
      setShowNotification(false);
      setIsExiting(false);
    }, 300); // Animation duration
  };

  // Handle close button click
  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleCloseWithAnimation();
  };

  if (!currentNotification || !showNotification) return null;

  return (
    <div className="notification-container">
      <div
        className={`notification-wrapper ${
          isExiting ? "notification-exit" : "notification-enter"
        }`}
      >
        <div className="notification-timer timer-animation"></div>

        <Link to={`/Productdetail/${currentNotification.id}`}>
          <div className="notification-content">
            <div className="notification-image-container">
              <img
                src={currentNotification.images?.[0]?.image || ""}
                alt={currentNotification.name || "Product Image"}
                className="notification-image"
              />
              <div className="notification-badge fade-in">NEW</div>
            </div>

            <div className="notification-text">
              <h3 className="notification-title">{currentNotification.name}</h3>
              <p className="notification-subtitle">Try Our Trending Product</p>

              <div className="notification-metadata">
                <div className="metadata-item">
                  <FaTag className="metadata-icon" />
                  <span>ID: {currentNotification.id}</span>
                </div>
                <div className="metadata-item">
                  <FaEye className="metadata-icon" />
                  <span>{Math.floor(Math.random() * 20) + 5} viewing</span>
                </div>
              </div>
            </div>

            <button onClick={handleClose} className="notification-close">
              <IoCloseCircle size={24} />
            </button>
          </div>

          <div className="notification-border"></div>
        </Link>
      </div>
    </div>
  );
};

export default Notification;
